<div class="NgxEditor__Wrapper">
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
  <ngx-editor
    [editor]="editor"
    [ngModelOptions]="{ standalone: true }"
    [ngModel]="text"
    [disabled]="false"
    [placeholder]="'Type here...'"
  ></ngx-editor>
</div>
